import { call, put, takeLatest, fork, all } from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as API from '../helpers/apiUrl';
import * as Func from "../helpers/functions";
import $ from 'jquery';
import i18n from "../constants/initLng";

import * as Customer from '../actions/customerAction';

function* listCustomer(action) {
    try {
        let PageIndex = undefined;
        let PageSize = undefined;
        let arrayFilters = [];
        let filters = "";
        let showUrl = false;
        if (action.filters !== undefined) {
            showUrl = true;
            for (var key in action.filters) {
                if (key !== "PageIndex" && key !== "PageSize") {
                    arrayFilters.push(`${key}=${action.filters[key]}`);
                } else if (key === "PageIndex") {
                    if(action.filters[key] > 1){PageIndex = action.filters[key];}
                } else if (key === "PageSize") {
                    if(action.filters[key] > 10){PageSize = action.filters[key];}
                }
            }
            if(arrayFilters.length > 0){
                showUrl= true;
                filters = arrayFilters.join("&");
                if(PageIndex > 1 || PageSize > 10){
                    filters = "&"+filters;
                }else{
                    filters = "?"+filters;
                }
            }
        } else {
            showUrl = false;
        }
        const link = `customer${showUrl ? `${PageIndex > 1 ? `?PageIndex=${PageIndex}` : ""}${(PageSize > 10 && PageIndex > 1) ? `&PageSize=${PageSize}` : (PageSize > 10) ? `?PageSize=${PageSize}` : ""}${filters}` : ""}`;
        const method = "GET";
        const body = null;
        const data = yield call(API.apiProductUrl, link, method, body);
        if(data.status === 403){
            Func.alertMessage(i18n.t('notifi.title'), i18n.t('Bạn không thể vào trang này'), true);
            return false;
        }
        yield put(Customer.dataCustomerSuccess(data.data.data));
    } catch (e) {
        // Func.alertMessage(i18n.t('notifi.title'), i18n.t('validation.connectfail'), true);
        // $("div.alert").slideDown(300);
    }
}

function* showDataCustomer() {
    yield takeLatest(Types.CUSTOMER_LIST_ACTION, listCustomer);
}

function* exCustomer(action) {
    try {
        let dataFilter = {...action.filters.data,culture: i18n.t('exportLang')};
        if(dataFilter){
            let params = [];
            Object.keys(dataFilter).map((i) => {
                if(dataFilter[i]){
                    params.push(`${i}=${dataFilter[i]}`);
                }
            });
            let urlEx =params.join("&");
            const link = `customer/${action.filters.nameEx}?${urlEx}`;
            const method = "GET";
            const body = null;
            const data = yield call(API.apiProductUrl, link, method, body,true);
            let fileName = data.headers['x-suggestion-filename'];
            Func.downloadFile(data.data,fileName);
        }else{
            const link = `customer/${action.filters.nameEx}`;
            const method = "GET";
            const body = null;
            const data = yield call(API.apiProductUrl, link, method, body,true);
            let fileName = data.headers['x-suggestion-filename'];
            Func.downloadFile(data.data,fileName);
        }
    } catch (e) {
        // Func.alertMessage(i18n.t('notifi.title'), i18n.t('validation.connectfail'), true);
        // $("div.alert").slideDown(300);
    }
}

function* showDataExCustomer() {
    yield takeLatest(Types.CUSTOMER_EXPORT_ACTION, exCustomer);
}

function* getItemCustomer(action){
    try {
        const method = "GET";
        const body = null;
        const link = `customer/${action.params.id}`;
        const data = yield call(API.apiProductUrl,link,method,body);
        if(!data.data.errors){
            yield put(Customer.getCustomerSuccess(data.data.data));
            window.showModal('onActionCustomer');
        }
    } catch (e) {
        // Func.alertMessage(i18n.t('notifi.title'), i18n.t('validation.connectfail'), true);
        // $("div.alert").slideDown(300);
    }
}

function* showGetItemCustomer(){
    yield takeLatest(Types.CUSTOMER_GET_ITEM_ACTION,getItemCustomer);
}

function* updateCustomer(action){
    try {
        const link = `customer/${action.params.data.id}`;
        const method = "PUT";
        const body = action.params.data;
        const data = yield call(API.apiProductUrl,link,method,body);
        if(!data.data.errors){
            Func.alertMessage(i18n.t('notifi.title'), i18n.t('notifi.updatesuccess'));
            yield call(listCustomer,{filters:action.params.PageIndex});
            $('.close').click();
        }else{
            yield call(listCustomer,{filters:action.params.PageIndex});
            Func.alertMessage(i18n.t('notifi.title'), data.data.errors, true);
        }
    } catch (e) {
        Func.alertMessage(i18n.t('notifi.title'), 'Tài khoản đã tồn tại, Vui lòng nhập lại', true);
    }
}

function* showUpdateCustomer(){
    yield takeLatest(Types.CUSTOMER_UPDATE_ACTION,updateCustomer);
}

function* filterGetAllCustomer(action){
    try {
        let PageIndex = undefined;
        let PageSize = undefined;
        let arrayFilters = [];
        let filters = "";
        let showUrl = false;
        if (action.filters !== undefined) {
            showUrl = true;
            for (var key in action.filters) {
                if (key !== "PageIndex" && key !== "PageSize") {
                    arrayFilters.push(`${key}=${action.filters[key]}`);
                } else if (key === "PageIndex") {
                    if(action.filters[key] > 1){PageIndex = action.filters[key];}
                } else if (key === "PageSize") {
                    if(action.filters[key] > 10){PageSize = action.filters[key];}
                }
            }
            if(arrayFilters.length > 0){
                showUrl= true;
                filters = arrayFilters.join("&");
                if(PageIndex > 1 || PageSize > 10){
                    filters = "&"+filters;
                }else{
                    filters = "?"+filters;
                }
            }
        } else {
            showUrl = false;
        }
        const link = `customer/all${showUrl ? `${PageIndex > 1 ? `?PageIndex=${PageIndex}` : ""}${(PageSize > 10 && PageIndex > 1) ? `&PageSize=${PageSize}` : (PageSize > 10) ? `?PageSize=${PageSize}` : ""}${filters}` : ""}`;
        const method = "GET";
        const body = null;
        const data = yield call(API.apiProductUrl, link, method, body);
        if(data.status === 403){
            Func.alertMessage(i18n.t('notifi.title'), i18n.t('Bạn không thể vào trang này'), true);
            return false;
        }
        yield put(Customer.filterGetAllCustomerSuccess(data.data.data));
    } catch (e) {
        // Func.alertMessage(i18n.t('notifi.title'), 'Tài khoản đã tồn tại, Vui lòng nhập lại', true);
    }
}

function* showFilterGetAllCustomer(){
    yield takeLatest(Types.CUSTOMER_FILTER_GET_ALL_ACTION,filterGetAllCustomer);
}

export function* customerSaga() {
    yield all([
        fork(showDataCustomer),
        fork(showDataExCustomer),
        fork(showGetItemCustomer),
        fork(showUpdateCustomer),
        fork(showFilterGetAllCustomer),
    ])
}
